export type AppConfigType = {
  api: AppConfigApiType;
  app: AppConfigAppType;
  companyInfo: AppConfigCompanyInfoType;
  theme: AppConfigThemeType;
  front: AppConfigFrontType;
  notification: AppConfigNotificationType;
};

type AppConfigFrontType = {
  "401Redirect": string;
  hostname: string;
};

type AppConfigApiType = {
  endpoint: string;
  port: number;
  production: boolean;
  routePrefix: string;
  signinRoute: string;
  signoutRoute: string;
  currentUser: string;
  versionCheckerEndpoint: string;
  authServerToken: string;
};

type AppConfigAppType = {
  beta: boolean;
  alphaWatermark: boolean;
  favicon: string;
  logo: string;
  logoDarkMode: string;
  notFoundImage: string;
  showPLSignin: boolean;
  showForgotPassword: boolean;
  showSignup: boolean;
  rootBackground: string;
  title: string;
  serviceLevelLogo: { economy: string; premium: string; guaranteed: string };
  loadStatusLogo: {
    cancelled: string;
    enRoute: string;
    processing: string;
    pending: string;
    dropped: string;
    toDelivery: string;
    toPickup: string;
    delivered: string;
  };
  reeferLogo: string;
};

type AppConfigCompanyInfoType = {
  contact: string;
  name: string;
  support: string;
  website: string;
};

type AppConfigThemeType = {
  primaryColor: string;
  secondaryColor: string;
};

type AppConfigNotificationType = {
  success?: {
    variant?: "intrusive" | "non-intrusive";
    autohide?: boolean;
    autoHideDuration?: number;
  };
  error?: {
    variant?: "intrusive" | "non-intrusive";
    autohide?: boolean;
    autoHideDuration?: number;
  };
};

declare global {
  interface Window {
    _APP_CONFIG: AppConfigType;
  }
}

window._APP_CONFIG = window._APP_CONFIG || {};

export const AppConfig = window._APP_CONFIG;
